export default __webpack_public_path__ + "c13f13d6af60721d2ae845d4e79f5612.jpg";